import { useAsync } from '@flowwai-frontend/shared/common-components'

import { LoginWithEmailRequestType } from '../../services/types'

import { useLoginService } from '../services/useLoginService'

const useLoginWithEmailAPI = () => {
   const loginService = useLoginService()

   const {
      mutateAsync: loginWithEmailAPI,
      apiStatus: loginWithEmailAPIStatus,
      error: loginWithEmailAPIError
   } = useAsync<unknown, Error, LoginWithEmailRequestType>(
      loginService.loginWithEmail
   )

   return {
      loginWithEmailAPI,
      loginWithEmailAPIStatus,
      loginWithEmailAPIError
   }
}

export { useLoginWithEmailAPI }
